<template>
  <v-tooltip
    :disabled="itemModified.tooltip === undefined || $vuetify.display.smAndDown"
    location="bottom"
  >
    <template #activator="{ props }">
      <v-btn
        :class="[
          isFirstItem && !doubleItems ? 'first-child' : 'flex-1',
          {
            'button-style-md-screens': mdScreens,
            'buttons-md-style': multipleItems && !isFirstItem,
          },
        ]"
        :variant="!itemModified.active ? 'outlined' : 'flat'"
        class="mr-1 mr-lg-2"
        color="primary"
        v-bind="props"
        @click="selectFilter(itemModified)"
      >
        <span v-if="itemModified.title !== 'ALL'">{{
          itemModified.title
        }}</span>
        <v-icon v-else color="primary" size="large"> fas fa-sync </v-icon>
      </v-btn>
    </template>
    <span>{{ itemModified.tooltip }}</span>
  </v-tooltip>
</template>

<script>
import { isEqual } from "lodash-es";
import { mapActions } from "vuex";
import customIcons from "@/plugins/icons";

import currentParameter from "@/utils/currentParameterMixin.js";

export default {
  name: "FilterButton",
  mixins: [currentParameter],
  props: {
    item: { default: () => ({}), type: Object },
    isFirstItem: { default: false, type: Boolean },
    mdScreens: { default: null, type: Boolean },
    itemParentIndex: { default: 0, type: Number },
    multipleItems: { default: false, type: Boolean },
    doubleItems: { default: false, type: Boolean },
  },
  data: () => {
    return {
      itemModified: { default: null, type: Object },
      customIcons: customIcons,
    };
  },
  watch: {
    currentParameter: {
      handler(newVal) {
        const _module = this;
        const fieldName = _module.itemModified.filterName;
        const fieldValue = newVal[fieldName];
        const currentValue = _module.itemModified.value;
        const title = _module.itemModified.title;
        _module.checkCurrentParameters(title, fieldValue, currentValue);
      },
      deep: true,
    },
  },
  mounted() {
    //Commenting nexttick as it was changing the order of filters
    // this.$nextTick(function () {
    const _module = this;
    _module.itemModified = JSON.parse(JSON.stringify(this.item));
    const fieldValue = _module.currentParameter[this.itemModified.filterName];
    const currentValue = _module.itemModified.value;
    const title = _module.itemModified.title;
    _module.checkCurrentParameters(title, fieldValue, currentValue);
    // });
  },
  methods: {
    ...mapActions("searchFilters", ["resetFilterButtons", "activateButton"]),
    checkCurrentParameters: function (title, fieldValue, currentValue) {
      if (fieldValue === null) {
        this.itemModified.active =
          title === "all" || title === "match all terms";
      }
      else {
        if (currentValue === undefined) {
          this.itemModified.active = false;
        }
        else {
          this.itemModified.active = currentValue.toString() === fieldValue;
        }
      }
    },
    /**
     * Apply the filters by building the new query parameters using the form data.
     */
    applyFilters: function (selectedItem) {
      const _module = this;
      let currentQuery = {};
      let oldQuery = {};

      Object.keys(_module.$route.query).forEach(function (param) {
        currentQuery[param] = _module.$route.query[param];
        oldQuery[param] = _module.$route.query[param];
      });
      Object.prototype.hasOwnProperty.call(selectedItem, "value")
        ? (currentQuery[selectedItem.filterName] = encodeURIComponent(
          selectedItem.value,
        ))
        : delete currentQuery[selectedItem.filterName];
      if (!isEqual(currentQuery, oldQuery)) {
        currentQuery["page"] = 1;
        this.$router.push({
          name: _module.$route.name,
          query: currentQuery,
        });
      }
    },
    selectFilter: function (selectedItem) {
      let _module = this;
      _module.resetFilterButtons(_module.itemParentIndex);
      _module.activateButton({
        activeItem: selectedItem,
        itemParentIndex: _module.itemParentIndex,
      });
      this.applyFilters(selectedItem);
    },
  },
};
</script>

<style scoped>
.button-style-md-screens {
  font-size: 9px !important;
}

.first-child {
  font-size: 11px;
  width: 16.5%;
}

.flex-1 {
  font-size: 11px;
  flex: 1;
}

.buttons-md-style {
  min-width: 32px !important;
}
</style>
